<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Osf9ud/tc-custom/9781611210378.jpg?1718071454595" alt="This image is the cover for the book Once a Marine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Once a Marine
      </h1>
      <p class="bookDescription body article font2">
        <b>The Silver Star–awarded marine chronicles his service in Iraq in this “transcendent memoir of military service and its personal consequences” (Ralph Peters, Lt. Col., ret., author of Looking For Trouble).</b><br/>  <br/> In April, 2003, an AP photographer captured a striking image seen around the world of Gunny Sergeant Nick Popaditch smoking a victory cigar in his tank, the haunting statue of Saddam Hussein hovering in the background. Though immortalized in that moment as “The Cigar Marine,” Popaditch’s fighting was far from over.<br/>  <br/> The following year, he fought heroically in the battle for Fallujah and suffered grievous head wounds that left him legally blind and partially deaf. But he faced the toughest fight of his life when he returned home: the battle to remain the man and Marine he was.<br/>  <br/> At first, Nick fights to get back to where he was in Iraq-in the cupola of an M1A1 main battle tank, leading Marines in combat. As the seriousness and permanence of his disabilities become more evident, Nick fights to remain in the Corps in any capacity and help his brothers in arms. Then, following a medical retirement, he battles for rightful recognition and compensation for his disabilities. Throughout his harrowing ordeal, Nick fights to maintain his honor and loyalty, waging all these battles the same way—the Marine way—because anything less would be a betrayal of all he holds dear.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nick Popaditch, Mike Steere
      </h2>
      
      <p class="authorDescription body article">From East Chicago, Indiana, Nick Popaditch enlisted in the Marine Corps in 1986. He was wounded while commanding a tank in Fallujah (Iraq) in 2004 and medically retired from the Marines in 2005 at the rank of Gunnery Sergeant. “Gunny” and his wife April have two children, Richard and Nicholas. They reside in Chula Vista, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e52f6146